import { FormTemplateType, Patient, Project } from 'api/models';
import { query } from 'operations';

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import {
  projectState,
  selectedFormTemplateTypeState,
  selectedPatientState,
} from 'state';
import { GeneralIds, ModelTypes } from 'types/types';

export function useSaveDataFromUrl() {
  const setProjectStore = useSetRecoilState(projectState);
  const setPatient = useSetRecoilState(selectedPatientState);
  const setFormTemplateType = useSetRecoilState(selectedFormTemplateTypeState);
  const { projectId, patientId, visitId, formTemplateTypeId, formId, userId } =
    useParams<GeneralIds>();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data: projects } = await query<Project[]>({
          type: ModelTypes.project,
        });

        setProjectStore({
          projects: projects ?? [],
          selectedProject: null,
        });

        if (projectId) {
          setProjectStore({
            projects: projects ?? [],
            selectedProject: projects.find(project => project.id === projectId),
          });
        }

        if (patientId) {
          const { data: patient } = await query<Patient>({
            type: ModelTypes.patient,
            ids: { id: patientId, projectId },
          });

          setPatient(patient);
        }

        if (formTemplateTypeId) {
          const { data: formTemplateType } = await query<FormTemplateType>({
            type: ModelTypes.formTemplateType,
            ids: { id: formTemplateTypeId, projectId },
          });
          setFormTemplateType(formTemplateType);
        }
        setIsLoading(false);
      } catch (error: any) {
        // 1.5 is standing for invalid bearer token
        if (error?.response?.data?.error?.[0]?.code === '1.5') {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
        setIsLoading(false);
      }
    }
    fetchData();
  }, [
    projectId,
    patientId,
    visitId,
    formTemplateTypeId,
    formId,
    userId,
    setProjectStore,
    setPatient,
    setFormTemplateType,
  ]);

  return {
    isLoading,
  };
}
